(() => {
  const initHeader = (scope = document) => {
    const toggle = scope.querySelector('[data-nav-toggle]');
    const nav = scope.querySelector('[data-nav]');
    if (toggle && nav && !toggle.dataset.bound) {
      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        nav.classList.toggle('is-open', !open);
      });
    }
    scope.querySelectorAll('[data-dropdown-toggle]').forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const item = button.closest('.has-dropdown');
        const open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      nav?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      scope.querySelectorAll('.has-dropdown.is-open').forEach((item) => item.classList.remove('is-open'));
    }, { once: true });
  };
  const init = (scope = document) => {
    initHeader(scope);
    scope.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.dataset.smoothBound) return;
      link.dataset.smoothBound = 'true';
      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        const target = document.querySelector(id);
        if (target) { event.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
